export const CHECK_TEMPLATE_NAME = 'CHECK_TEMPLATE_NAME';
export const CHECK_TEMPLATE_NAME_SUCCESS = 'CHECK_TEMPLATE_NAME_SUCCESS';
export const CHECK_TEMPLATE_NAME_FAILED = 'CHECK_TEMPLATE_NAME_FAILED';
export const RESET_TEMPLATE_NAME_VALID = 'RESET_TEMPLATE_NAME_VALID';

export const UPDATE_TEMPLATE_DETAILS = 'UPDATE_TEMPLATE_DETAILS';

export const REMOVE_SLOT_FROM_SESSION = 'REMOVE_SLOT_FROM_SESSION';

export const SEARCH_TEMPLATEDRAFTS = 'SEARCH_TEMPLATEDRAFTS';
export const SEARCH_TEMPLATEDRAFTS_SUCCESS = 'SEARCH_TEMPLATEDRAFTS_SUCCESS';
export const SEARCH_TEMPLATEDRAFTS_FAILED = 'SEARCH_TEMPLATEDRAFTS_FAILED';

export const SEARCH_TEMPLATES = 'SEARCH_TEMPLATES';
export const SEARCH_TEMPLATES_SUCCESS = 'SEARCH_TEMPLATES_SUCCESS';
export const SEARCH_TEMPLATES_FAILED = 'SEARCH_TEMPLATES_FAILED';
export const SET_SEARCH_TEMPLATES = 'SET_SEARCH_TEMPLATES';
export const SET_SORT_CRITERIAS = 'SET_SORT_CRITERIAS';

export const FETCH_EXAM_TYPES = 'FETCH_EXAM_TYPES';
export const SET_EXAM_TYPES = 'SET_EXAM_TYPES';

export const FETCH_TEMPLATE_DETAILS = 'FETCH_TEMPLATE_DETAILS';
export const FETCH_TEMPLATE_DETAILS_SUCCESS = 'FETCH_TEMPLATE_DETAILS_SUCCESS';
export const FETCH_TEMPLATE_DETAILS_FAILED = 'FETCH_TEMPLATE_DETAILS_FAILED';

export const FETCH_LIVERANGETEMPLATE_DETAILS = 'FETCH_LIVERANGETEMPLATE_DETAILS';
export const FETCH_LIVERANGETEMPLATE_DETAILS_SUCCESS = 'FETCH_LIVERANGETEMPLATE_DETAILS_SUCCESS';
export const FETCH_LIVERANGETEMPLATE_DETAILS_FAILED = 'FETCH_LIVERANGETEMPLATE_DETAILS_FAILED';

export const FETCH_TEMPLATEDRAFT_DETAILS = 'FETCH_TEMPLATEDRAFT_DETAILS';
export const FETCH_TEMPLATEDRAFT_DETAILS_SUCCESS = 'FETCH_TEMPLATEDRAFT_DETAILS_SUCCESS';
export const FETCH_TEMPLATEDRAFT_DETAILS_FAILED = 'FETCH_TEMPLATEDRAFT_DETAILS_FAILED';

export const REMOVE_TEMPLATES = 'REMOVE_TEMPLATES';
export const REMOVE_TEMPLATES_SUCCESS = 'REMOVE_TEMPLATES_SUCCESS';
export const REMOVE_TEMPLATES_FAILED = 'REMOVE_TEMPLATES_FAILED';
export const REMOVE_TEMPLATEDRAFTS = 'REMOVE_TEMPLATEDRAFTS';
export const REMOVE_TEMPLATEDRAFTS_SUCCESS = 'REMOVE_TEMPLATEDRAFTS_SUCCESS';
export const REMOVE_TEMPLATEDRAFTS_FAILED = 'REMOVE_TEMPLATEDRAFTS_FAILED';

export const RENAME_TEMPLATE = 'RENAME_TEMPLATE';
export const RENAME_TEMPLATE_SUCCESS = 'RENAME_TEMPLATE_SUCCESS';
export const RENAME_TEMPLATE_FAILED = 'RENAME_TEMPLATE_FAILED';

export const SET_EDITED_EXAM = 'SET_EDITED_EXAM';
export const SET_ADDED_EXAM = 'SET_ADDED_EXAM';

export const IMPORT_FILE = 'IMPORT_FILE';
export const IMPORT_FILE_SUCCESS = 'IMPORT_FILE_SUCCESS';
export const IMPORT_FILE_FAILED = 'IMPORT_FILE_FAILED';

export const CLEAN_IMPORT_LAYOUT = 'CLEAN_IMPORT_LAYOUT';
export const UPDATE_VALIDATED_IMPORT = 'UPDATE_VALIDATED_IMPORT';
export const UPDATE_VALIDATED_IMPORT_SUCCESS = 'UPDATE_VALIDATED_IMPORT_SUCCESS';
export const UPDATE_VALIDATED_IMPORT_FAILED = 'UPDATE_VALIDATED_IMPORT_FAILED';

export const UNMAP_OFFICE = 'UNMAP_OFFICE';
export const UNMAP_OFFICE_SUCCESS = 'UNMAP_OFFICE_SUCCESS';
export const UNMAP_OFFICE_FAILED = 'UNMAP_OFFICE_FAILED';
export const SET_CAN_ADD_EXAM = 'SET_CAN_ADD_EXAM';

export const CLONE_TEMPLATE_DETAILS = 'CLONE_TEMPLATE_DETAILS';
export const CLONE_TEMPLATE_DETAILS_SUCCESS = 'CLONE_TEMPLATE_DETAILS_SUCCESS';
export const CLONE_TEMPLATE_DETAILS_FAILED = 'CLONE_TEMPLATE_DETAILS_FAILED';
export const RESET_CLONE_SUCCESS = 'RESET_CLONE_SUCCESS';

export const CREATE_TEMPLATE_DETAILS = 'CREATE_TEMPLATE_DETAILS';
export const CREATE_TEMPLATE_DETAILS_SUCCESS = 'CREATE_TEMPLATE_DETAILS_SUCCESS';
export const CREATE_TEMPLATE_DETAILS_FAILED = 'CREATE_TEMPLATE_DETAILS_FAILED';

export const CREATE_TEMPLATEDRAFT_DETAILS = 'CREATE_TEMPLATEDRAFT_DETAILS';
export const CREATE_TEMPLATEDRAFT_DETAILS_SUCCESS = 'CREATE_TEMPLATEDRAFT_DETAILS_SUCCESS';
export const CREATE_TEMPLATEDRAFT_DETAILS_FAILED = 'CREATE_TEMPLATEDRAFT_DETAILS_FAILED';

export const PUBLISH_DRAFT = 'PUBLISH_DRAFT';
export const PUBLISH_DRAFT_SUCCESS = 'PUBLISH_DRAFT_SUCCESS';
export const PUBLISH_DRAFT_FAILED = 'PUBLISH_DRAFT_FAILED';

export const UPDATE_TEMPLATE_SLOT_DETAILS = 'UPDATE_TEMPLATE_SLOT_DETAILS';
export const UPDATE_TEMPLATE_SLOT_DETAILS_SUCCESS = 'UPDATE_TEMPLATE_SLOT_DETAILS_SUCCESS';
export const UPDATE_TEMPLATE_SLOT_DETAILS_FAILED = 'UPDATE_TEMPLATE_SLOT_DETAILS_FAILED';

export const UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS = 'UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS';
export const UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_SUCCESS =
  'UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_SUCCESS';
export const UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_FAILED =
  'UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_FAILED';

export const UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS = 'UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS';
export const UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_SUCCESS = 'UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_SUCCESS';
export const UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_FAILED = 'UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_FAILED';

export const UPDATE_TEMPLATEDRAFT_SLOT_DETAILS = 'UPDATE_TEMPLATEDRAFT_SLOT_DETAILS';
export const UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_SUCCESS = 'UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_SUCCESS';
export const UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_FAILED = 'UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_FAILED';

export const SET_SELECTED_HOO = 'SET_SELECTED_HOO';

export const BULK_CLONE_TEMPLATES = 'BULK_CLONE_TEMPLATES';
export const BULK_CLONE_TEMPLATES_SUCCESS = 'BULK_CLONE_TEMPLATES_SUCCESS';
export const BULK_CLONE_TEMPLATES_FAILED = 'BULK_CLONE_TEMPLATES_FAILED';

export const bulkCloneTemplates = (payload) => ({
  type: BULK_CLONE_TEMPLATES,
  payload,
});

export const bulkCloneTemplatesSuccess = (payload) => ({
  type: BULK_CLONE_TEMPLATES_SUCCESS,
  payload,
});

export const bulkCloneTemplatesFailed = (payload) => ({
  type: BULK_CLONE_TEMPLATES_FAILED,
  payload,
});

export const removeSlotFromSession = (item) => ({
  type: REMOVE_SLOT_FROM_SESSION,
  payload: item,
});

export const updateTemplateDetails = (payload) => ({
  type: UPDATE_TEMPLATE_DETAILS,
  payload,
});

export const setSearchTemplates = (payload) => ({
  type: SET_SEARCH_TEMPLATES,
  payload,
});

export const searchTemplates = (payload) => ({
  type: SEARCH_TEMPLATES,
  payload,
});

export const setSortCriterias = (payload) => ({
  type: SET_SORT_CRITERIAS,
  payload,
});

export const searchTemplatesSuccess = (payload) => ({
  type: SEARCH_TEMPLATES_SUCCESS,
  payload,
});

export const searchTemplatesFailed = (payload) => ({
  type: SEARCH_TEMPLATES_FAILED,
  payload,
});

export const searchTemplateDrafts = (payload) => ({
  type: SEARCH_TEMPLATEDRAFTS,
  payload,
});
export const searchTemplateDraftsSuccess = (payload) => ({
  type: SEARCH_TEMPLATEDRAFTS_SUCCESS,
  payload,
});

export const searchTemplateDraftsFailed = (payload) => ({
  type: SEARCH_TEMPLATEDRAFTS_FAILED,
  payload,
});

export const fetchExamTypes = () => ({
  type: FETCH_EXAM_TYPES,
});

export const setExamTypes = (payload) => ({
  type: SET_EXAM_TYPES,
  payload,
});

export const fetchTemplateDetails = (payload) => ({
  type: FETCH_TEMPLATE_DETAILS,
  payload,
});

export const fetchTemplateDraftDetails = (payload) => ({
  type: FETCH_TEMPLATEDRAFT_DETAILS,
  payload,
});

export const fetchTemplateDraftDetailsSuccess = (payload) => ({
  type: FETCH_TEMPLATEDRAFT_DETAILS_SUCCESS,
  payload,
});

export const fetchTemplateDraftDetailsFailed = (payload) => ({
  type: FETCH_TEMPLATEDRAFT_DETAILS_FAILED,
  payload,
});

export const fetchTemplateDetailsSuccess = (payload) => ({
  type: FETCH_TEMPLATE_DETAILS_SUCCESS,
  payload,
});

export const fetchTemplateDetailsFailed = (payload) => ({
  type: FETCH_TEMPLATE_DETAILS_FAILED,
  payload,
});

export const fetchLiveRangeTemplateDetails = (payload) => ({
  type: FETCH_LIVERANGETEMPLATE_DETAILS,
  payload,
});
export const fetchLiveRangeTemplateDetailsSuccess = (payload) => ({
  type: FETCH_LIVERANGETEMPLATE_DETAILS_SUCCESS,
  payload,
});

export const fetchLiveRangeTemplateDetailsFailed = (payload) => ({
  type: FETCH_LIVERANGETEMPLATE_DETAILS_FAILED,
  payload,
});

export const setEditedExam = (payload) => ({
  type: SET_EDITED_EXAM,
  payload,
});

export const setAddedExam = (payload) => ({
  type: SET_ADDED_EXAM,
  payload,
});

export const removeTemplate = (payload) => ({
  type: REMOVE_TEMPLATES,
  payload,
});

export const removeTemplateDrafts = (payload) => ({
  type: REMOVE_TEMPLATEDRAFTS,
  payload,
});

export const removeTemplateSuccess = (payload) => ({
  type: REMOVE_TEMPLATES_SUCCESS,
  payload,
});

export const removeTemplateFailed = (payload) => ({
  type: REMOVE_TEMPLATES_FAILED,
  payload,
});

export const removeTemplateDraftsSuccess = (payload) => ({
  type: REMOVE_TEMPLATEDRAFTS_SUCCESS,
  payload,
});

export const removeTemplateDraftsFailed = (payload) => ({
  type: REMOVE_TEMPLATEDRAFTS_FAILED,
  payload,
});

export const renameTemplate = (payload) => ({
  type: RENAME_TEMPLATE,
  payload,
});

export const renameTemplateSuccess = (payload) => ({
  type: RENAME_TEMPLATE_SUCCESS,
  payload,
});

export const renameTemplateFailed = (payload) => ({
  type: RENAME_TEMPLATE_FAILED,
  payload,
});

export const importFile = (payload, actionType) => ({
  type: IMPORT_FILE,
  payload,
  actionType,
});

export const importFileSuccess = (payload, totalCount, validationErrors) => ({
  type: IMPORT_FILE_SUCCESS,
  payload,
  totalCount,
  validationErrors,
});

export const importFileFailed = (payload) => ({
  type: IMPORT_FILE_FAILED,
  payload,
});

export const cleanImportLayout = () => ({
  type: CLEAN_IMPORT_LAYOUT,
});

export const updateValidatedImport = (payload, actionType, flag) => ({
  type: UPDATE_VALIDATED_IMPORT,
  payload,
  actionType,
  flag,
});

export const updateValidatedSuccess = (payload) => ({
  type: UPDATE_VALIDATED_IMPORT_SUCCESS,
  payload,
});

export const updateValidatedFailed = (payload) => ({
  type: UPDATE_VALIDATED_IMPORT_FAILED,
  payload,
});

export const unmappOffice = (payload) => ({
  type: UNMAP_OFFICE,
  payload,
});

export const unmappOfficeSuccess = (payload) => ({
  type: UNMAP_OFFICE_SUCCESS,
  payload,
});

export const unmappOfficeFailed = (payload) => ({
  type: UNMAP_OFFICE_FAILED,
  payload,
});

export const setCanAddExam = (payload) => ({
  type: SET_CAN_ADD_EXAM,
  payload,
});

export const cloneTemplateDetails = (payload) => ({
  type: CLONE_TEMPLATE_DETAILS,
  payload,
});

export const resetCloneSuccess = () => ({
  type: RESET_CLONE_SUCCESS,
});

export const cloneTemplateDetailsSuccess = (payload) => ({
  type: CLONE_TEMPLATE_DETAILS_SUCCESS,
  payload,
});

export const cloneTemplateDetailsFailed = (payload) => ({
  type: CLONE_TEMPLATE_DETAILS_FAILED,
  payload,
});

export const updateTemplateSlotDetails = (payload) => ({
  type: UPDATE_TEMPLATE_SLOT_DETAILS,
  payload,
});

export const updateTemplateDraftSlotDetails = (payload) => ({
  type: UPDATE_TEMPLATEDRAFT_SLOT_DETAILS,
  payload,
});

export const updateTemplateDraftSlotDetailsSuccess = (payload) => ({
  type: UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_SUCCESS,
  payload,
});

export const updateTemplateDraftSlotDetailsFailed = (payload) => ({
  type: UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_FAILED,
  payload,
});

export const publishDraft = (payload) => ({
  type: PUBLISH_DRAFT,
  payload,
});

export const publishDraftSuccess = (payload) => ({
  type: PUBLISH_DRAFT_SUCCESS,
  payload,
});

export const publishDraftFailed = (payload) => ({
  type: PUBLISH_DRAFT_FAILED,
  payload,
});

export const createTemplateDetails = (payload) => ({
  type: CREATE_TEMPLATE_DETAILS,
  payload,
});

export const createTemplateDetailsSuccess = (payload) => ({
  type: CREATE_TEMPLATE_DETAILS_SUCCESS,
  payload,
});

export const createTemplateDetailsFailed = (payload) => ({
  type: CREATE_TEMPLATE_DETAILS_FAILED,
  payload,
});

export const createTemplateDraftDetails = (payload) => ({
  type: CREATE_TEMPLATEDRAFT_DETAILS,
  payload,
});

export const createTemplateDraftDetailsSuccess = (payload) => ({
  type: CREATE_TEMPLATEDRAFT_DETAILS_SUCCESS,
  payload,
});

export const createTemplateDraftDetailsFailed = (payload) => ({
  type: CREATE_TEMPLATEDRAFT_DETAILS_FAILED,
  payload,
});

export const updateTemplateSlotDetailsSuccess = (payload) => ({
  type: UPDATE_TEMPLATE_SLOT_DETAILS_SUCCESS,
  payload,
});

export const updateTemplateSlotDetailsFailed = (payload) => ({
  type: UPDATE_TEMPLATE_SLOT_DETAILS_FAILED,
  payload,
});

export const saveSelectedHOO = (payload) => ({
  type: SET_SELECTED_HOO,
  payload,
});

export const checkTemplateName = (payload) => ({
  type: CHECK_TEMPLATE_NAME,
  payload,
});
export const checkTemplateNameSuccess = (payload) => ({
  type: CHECK_TEMPLATE_NAME_SUCCESS,
  payload,
});
export const checkTemplateNameFailed = (payload) => ({
  type: CHECK_TEMPLATE_NAME_FAILED,
  payload,
});

export const resetTemplateNameValid = () => ({
  type: RESET_TEMPLATE_NAME_VALID,
});

export const updateLiveSpecialRangeTemplateSlotDetails = (payload) => ({
  type: UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS,
  payload,
});

export const updateLiveSpecialRangeTemplateSlotDetailsSuccess = (payload) => ({
  type: UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_SUCCESS,
  payload,
});

export const updateLiveSpecialRangeTemplateSlotDetailsFailed = (payload) => ({
  type: UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_FAILED,
  payload,
});

export const updateLiveRange0TemplateSlotDetails = (payload) => ({
  type: UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS,
  payload,
});

export const updateLiveRange0TemplateSlotDetailsSuccess = (payload) => ({
  type: UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_SUCCESS,
  payload,
});

export const updateLiveRange0TemplateSlotDetailsFailed = (payload) => ({
  type: UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_FAILED,
  payload,
});
